/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Water Intake Calculator (Daily Hydration) — Toolverse`)
};

const es_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Ingesta de Agua (Hidratación Diaria) — Toolverse`)
};

const de_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trinkmengen-Rechner (Tägliche Flüssigkeitszufuhr) — Toolverse`)
};

const nl_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watervolume Calculator (Dagelijkse Hydratatie) — Toolverse`)
};

const fr_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur d'Apport en Eau (Hydratation Quotidienne) — Toolverse`)
};

const it_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di assunzione d'acqua (idratazione giornaliera) — Toolverse`)
};

const pt_br2_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Ingestão de Água (Hidratação Diária) — Toolverse`)
};

const pt_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Ingestão de Água (Hidratação Diária) — Toolverse`)
};

const ja_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水分摂取量計算機(1日の水分補給) — Toolverse`)
};

const zh_water_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`饮水量计算器（每日水分摄入）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_meta_title", locale)
	if (locale === "en") return en_water_meta_title(inputs)
	if (locale === "es") return es_water_meta_title(inputs)
	if (locale === "de") return de_water_meta_title(inputs)
	if (locale === "nl") return nl_water_meta_title(inputs)
	if (locale === "fr") return fr_water_meta_title(inputs)
	if (locale === "it") return it_water_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_water_meta_title(inputs)
	if (locale === "pt") return pt_water_meta_title(inputs)
	if (locale === "ja") return ja_water_meta_title(inputs)
	return zh_water_meta_title(inputs)
};